module.exports = require("change-case");